import { render, staticRenderFns } from "./AutoConfig.vue?vue&type=template&id=85a67b4a&scoped=true&"
import script from "./AutoConfig.vue?vue&type=script&lang=js&"
export * from "./AutoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a67b4a",
  null
  
)

export default component.exports